import React from 'react';
import SkeletonBlock from '../ui/SkeletonBlock';
import SkeletonRoot from '../ui/SkeletonRoot';

interface SyndicationDealsListSkeletonProps {
  loadingLabel?: string;
}

const SyndicationDealsListSkeleton: React.FC<SyndicationDealsListSkeletonProps> = ({
  loadingLabel = 'Loading deals',
}) => (
  <SkeletonRoot loadingLabel={loadingLabel}>
    <div className="space-y-3 py-4">
      {Array.from({ length: 5 }).map((_, i) => (
        <SkeletonBlock key={i} className="h-16 w-full rounded-xl" />
      ))}
    </div>
  </SkeletonRoot>
);

export default SyndicationDealsListSkeleton;
